import { withApollo } from "react-apollo";
import React from "react";
import { UpdateGenericMastersQuery } from "../../../services/graphql/queries/masters";
import ReactModal from "../../Common/ReactModal";
import DisplayErrors from "../../Common/DisplayErrors";
import { getMasterStatus } from "../../Common/ListOfStatus";
import {
  SET_TIMEOUT_VALUE,
  ALPHANUMERIC_NAME_VALIDATION
} from "../../../constants/app-constants";
import { alphanumericAcceptanceValidation } from "../../../miscellaneous/misc";
class GenericMasterEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Id: "",
      description: "",
      status: "",
      descriptionValid: true,
      descriptionMessage: "",
      errors: [],
      modalMessage: `${this.props.genericMaster.masterFor.description} Updated Successfully`,
      reactModalVisible: false,
      isSubmitDisable: false
    };

    this.resetForm = this.resetForm.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.submitModal = this.submitModal.bind(this);
  }
  closeModal() {
    this.setState({ reactModalVisible: false });
  }
  submitModal() {
    this.setState({ reactModalVisible: false });
    this.props.toggleEditMode(false);
  }
  handleValidation() {
    let fields = this.state;
    let formIsValid = true;
    let validationError = {
      descriptionValid: true,
      descriptionMessage: ""
    };
    if (!fields["description"]) {
      formIsValid = false;
      validationError.descriptionMessage = "Please provide a valid Description";
      validationError.descriptionValid = false;
    }
    if (
      fields["description"] &&
      !alphanumericAcceptanceValidation(
        fields["description"],
        ALPHANUMERIC_NAME_VALIDATION
      )
    ) {
      formIsValid = false;
      validationError.descriptionMessage =
        "Description must start with a character and can contain alphanumeric and &, _, /";
      validationError.descriptionValid = false;
    }
    this.setState(validationError);
    return formIsValid;
  }

  componentDidMount() {
    this.setState({ ...this.props.genericMaster });
    this.initialState = this.props.genericMaster;
  }

  resetForm() {
    this.setState({ ...this.initialState, errors: [] });
  }

  submitForm(e) {
    if (this.handleValidation()) {
      this.setState({ errors: [] });
      console.log("Submit Values: ", this.state);
      this.setState({ loading: true });
      this.props.client
        .mutate({
          mutation: UpdateGenericMastersQuery,
          variables: {
            Id: this.props.genericMaster._id,
            description: this.state.description,
            status: parseInt(this.state.status)
          },
          fetchPolicy: "no-cache"
        })
        .then(result => {
          this.props.onUpdateGenericMaster(this.state);
          this.setState({ reactModalVisible: true, isSubmitDisable: false });
        })
        .catch(error => {
          error.graphQLErrors.map(({ message }, i) => {
            this.setState({
              errors: [message],
              isSubmitDisable: false
            });
          });
          setTimeout(() => {
            this.setState({ errors: [], loading: false });
          }, SET_TIMEOUT_VALUE);
        });
    }
  }

  render() {
    const {
      _id,
      description,
      reactModalVisible,
      modalMessage,
      status,
      errors,
      isSubmitDisable,
      descriptionValid,
      descriptionMessage
    } = this.state;
    const statusOptions = getMasterStatus(this.props.genericMaster.status);
    var masterForValue = this.props.genericMaster.masterFor.description;
    return (
      <>
        <ReactModal
          reactModalVisible={reactModalVisible}
          closeModal={this.closeModal}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={false}
        />
        <div className="row">
          <div className="col-md-11">
            <h1 className="heading m-b-25">{`${masterForValue} ${_id}`}</h1>
          </div>
        </div>
        <div
          className="row"
          style={{
            display: errors.length === 0 ? "none" : "block"
          }}
        >
          <div className="col-md-6">
            <div className="alert alert-success" role="alert">
              <div className="row">
                <DisplayErrors errors={errors} />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {/* Form Section start */}
            <div className="box-card">
              <div className="row">
                <div className="col-md-6" />
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>
                      DESCRIPTION<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      ref="description"
                      className={
                        descriptionValid
                          ? "form-control"
                          : "form-control is-invalid"
                      }
                      placeholder="Enter Description"
                      maxLength={65}
                      value={description}
                      onChange={e => {
                        this.setState({
                          description: e.target.value.toUpperCase()
                        });
                      }}
                    />
                    <div className="invalid-feedback">{descriptionMessage}</div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>
                      Status<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-control light-green select-style-1"
                      ref="status"
                      value={status}
                      onChange={e => {
                        this.setState({ status: e.target.value });
                      }}
                    >
                      {statusOptions.length
                        ? statusOptions.map((data, index) => {
                            return (
                              <option key={index} value={data.id}>
                                {data.name}
                              </option>
                            );
                          })
                        : null}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row m-t-45 m-b-15">
                <div className="col-md-5">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={this.submitForm}
                    disabled={isSubmitDisable}
                  >
                    Submit
                  </button>

                  <button
                    type="button"
                    className="btn btn-light m-l-50"
                    onClick={this.resetForm}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
            {/* Form Section End */}
          </div>
        </div>
      </>
    );
  }
}

export default withApollo(GenericMasterEdit);
